import { render, staticRenderFns } from "./verPedidoVendedor.vue?vue&type=template&id=f9e61330"
import script from "./verPedidoVendedor.vue?vue&type=script&lang=js"
export * from "./verPedidoVendedor.vue?vue&type=script&lang=js"
import style0 from "./verPedidoVendedor.vue?vue&type=style&index=0&id=f9e61330&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports